"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNormalizedUsername = exports.getCognitoUser = void 0;
var amazon_cognito_identity_js_1 = require("amazon-cognito-identity-js");
/**
 * Takes the input of {string}
 * @returns {CognitoUser} returns a new CognitoUser object for the given username
 */
var getCognitoUser = function (username, poolInfo, isNormalize) {
    var userPool = new amazon_cognito_identity_js_1.CognitoUserPool(poolInfo);
    var userInfo = {
        Username: (0, exports.getNormalizedUsername)(username, isNormalize),
        Pool: userPool
    };
    return new amazon_cognito_identity_js_1.CognitoUser(userInfo);
};
exports.getCognitoUser = getCognitoUser;
/**
 * Takes the input of {string} and converts it to all lowercase
 * @returns {string} returns the input to lowercase when isNormalize is enabled
 */
var getNormalizedUsername = function (username, isNormalize) {
    if (username && isNormalize)
        return username.toLowerCase();
    else
        return username;
};
exports.getNormalizedUsername = getNormalizedUsername;
//# sourceMappingURL=index.js.map